import { NgModule } from '@angular/core';
import { provideNavConfig } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';
import { SMART_SEARCH_PATH } from './constants';
import { SmartSearchNavConfigProvider } from './smart-search-nav-config.provider';
import { CanAccessSmartSearchGuard } from './smart-search-navigation-guards';

export const loadModule = () => import('@capital-access/smart-search/client').then(m => m.SmartSearchClientModule);

@NgModule({
  imports: [
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: SMART_SEARCH_PATH,
          canActivate: [CanAccessSmartSearchGuard],
          loadChildren: loadModule
        }
      ]
    })
  ],
  providers: [provideNavConfig(SmartSearchNavConfigProvider), CanAccessSmartSearchGuard]
})
export class SmartSearchLazyModule {}
